import { render, staticRenderFns } from "./ProjectTalk.vue?vue&type=template&id=4efdf804&scoped=true&"
import script from "./ProjectTalk.vue?vue&type=script&lang=js&"
export * from "./ProjectTalk.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTalk.vue?vue&type=style&index=0&lang=css&"
import style1 from "../../css/newCreateProject.css?vue&type=style&index=1&id=4efdf804&scoped=true&lang=css&"
import style2 from "./ProjectTalk.vue?vue&type=style&index=2&id=4efdf804&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efdf804",
  null
  
)

export default component.exports